export interface ScaleChoice {
    value: string | number;
    label?: string | null;
}

/**
 * Labelled answers (AOFAS "None" = 40, WOMAC "Slight" = 1) are a choice list.
 * The score belongs in the data, not on the control, so these render as radios.
 * A numeric scale keeps the number: a blank label, or a label that is the value.
 */
export function isLabelledChoiceScale(options: ScaleChoice[]): boolean {
    if (options.length === 0) return false;
    return options.every((option) => {
        const label = option.label?.trim() ?? "";
        if (!label) return false;
        return label !== String(option.value);
    });
}
